import React, { useEffect, useContext, useState } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Button from '../../componentes/ui/Button';
import MiSelect from '../../componentes/formulario/MiSelect';
import FormInput from '../../componentes/formulario/FormInput';
import CheckIos from '../../componentes/ui/CheckIos';
import UplmPlusBtn from '../../componentes/formulario/UpmlPlusBtn/UplmPlusBtn';
import TextArea from '../../componentes/formulario/TextArea';
import { Spinner } from 'react-bootstrap';
import { Accordion, Card } from "react-bootstrap";
import swal from 'sweetalert';
import { alertService } from '../../services/alertservice';
import { Alert } from '../../componentes/ui/Alert';
import useLogicForm from '../../hooks/useLogicForm';
import Cookies from 'universal-cookie';
import { getApiUrl, axiosPost, MiReplaceAll, getAhoraddmmyyyy, getAhorayyyymmdd, getPantDocFromNivel, setStockOptionsSelectUbi, getStockOptionsSelectUbi, getTitle, encryptData, getDecodedCookie, getNumFromDataTraPdtAsignar, getNumNoLeidosExcedidos, getNumNoLeidosEnPlazo } from '../../helpers/helperApp';
import { Fragment } from 'react';
import FormRow from '../../componentes/formulario/FormRow';
import { NavLink } from 'react-router-dom';
import { debounceTime } from 'rxjs/operators';

$.DataTable = DataTable;
const url = window.location;

function Manlogv2V2(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ acordeonPrin, saveAcordeonPrin ] = useState(null); 
    const [ loading, saveLoading ] = useState(false); 
    const [ selectIdEquipo, saveSelectIdEquipo ] = useState(0);
    const [ inputDescripcion, saveInputDescripcion ] = useState("");
    const [ controlMantenimientos, saveControlMantenimientos ] = useState([]);
    const [ mantenimientosPendientes, saveMantenimientosPendientes ] = useState([]);
    const [ pendientesAsignar, savePendientesAsignar ] = useState([]);
    const [ historicos, saveHistoricos ] = useState([]);
    const [ showModal, saveShowModal ] = useState(false);    
    const [ accionModal, saveAccionModal ] = useState("");
    const [ backUpOptionsSelectEquipo, saveBackUpOptionsSelectEquipo ] = useState([]);    
    const [ selectIdEquipoModal, saveSelectIdEquipoModal ] = useState(0);       
    const [ inputModalFecPro, saveInputModalFecPro ] = useState("");
    const [ inputModalFecUlt, saveInputModalFecUlt ] = useState(getAhorayyyymmdd()+"T00:00");
    const [ checkModalAvisar, saveCheckModalAvisar ] = useState(true);
    const [ inputModalHoras, saveInputModalHoras ] = useState("");
    const [ inputModalHActuales, saveInputModalHActuales ] = useState("");
    const [ recurrencia, saveRecurrencia ] = useState("");
    const [ tipoRecurrenciaDocModal, saveTipoRecurrenciaDocModal ] = useState(0);
    const [ lineaEditar, saveLineaEditar ] = useState(null);
    const [ equipoAsociadoMant, saveEquipoAsociadoMant ] = useState(0);
    const [ adjuntos, saveAdjuntos ] = useState([]);
    const [ txtHeaderModal, saveTxtHeaderModal ] = useState("");
    const [ loadingFecPro, saveLoadingFecPro ] = useState(false);
    const [ showModalMensaje, saveShowModalMensaje ] = useState(false);
    const [ mensajeId, saveMensajeId] = useState(0);
    const [ mensajeEstado, saveMensajeEstado] = useState(0);
    const [ mensajeDe, saveMensajeDe] = useState(0);
    const [ mensajePara, saveMensajePara] = useState(0);
    const [ mensajeEnvio, saveMensajeEnvio] = useState("");
    const [ mensajeRecordatorio, saveMensajeRecordatorio] = useState("");
    const [ mensajeLimite, saveMensajeLimite] = useState("");
    const [ mensajeLectura, saveMensajeLectura] = useState("");
    const [ mensajeMsg, saveMensajeMsg ] = useState("");
    const [ totLin, saveTotLin ] = useState(0);
    const [ estDoc, saveEstDoc ] = useState(0);

    // ***** Custom Hook - Lógica de los formularios *****
    const { loadReg, saveLoadReg } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confPantalla.manlogv2.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        init();                     
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 

    },[confPantalla]);

    const init = async () => {
        // await loadControlMantenimientosTable();
        await loadMantenimientosPendientes();      
        await loadPendientesAsignar();
        await loadHistoricos();
    }

    const loadControlMantenimientosTable = async () => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.datatablecontrolmantenimientos.getdata, data, source.token);
               
        if( typeof respuesta.data !== "string" ){
            saveControlMantenimientos(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }

    const loadMantenimientosPendientes = async (btnDataTable=false) => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        if(btnDataTable == true){                        
            let btn = document.getElementsByClassName('filterBtnManlogV2');
            if(btn && btn[0] && btn[0].classList.contains('active')) {
                btn[0].classList.remove('active');
            } else if(btn && btn[0].classList) {
                btn[0].classList.add('active');
                data.append("filhis", true);
            }            
        }else{
            let btn = document.getElementsByClassName('filterBtnManlogV2');
            if(btn && btn[0] && btn[0].classList.contains('active')) {                
                data.append("filhis", true);
            }
        }
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.datatablemantenimientospendientes.getdata, data, source.token);
               
        if( typeof respuesta.data !== "string" ){            
            saveMantenimientosPendientes(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }


    const loadPendientesAsignar = async () => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.datatablependientesdeasignar.getdata, data, source.token);
               
        if( typeof respuesta.data !== "string" ){
            savePendientesAsignar(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }


    const loadHistoricos = async () => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.datatablehistoricos.getdata, data, source.token);
               
        if( typeof respuesta.data !== "string" ){
            saveHistoricos(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }

    const createNew = () => {
        saveAccionModal("crear");        
        saveShowModal(true);
        saveInputDescripcion(inputDescripcion); 
        saveSelectIdEquipoModal(selectIdEquipo);
        if(selectIdEquipo == 0){
            saveTipoRecurrenciaDocModal(0);
            saveRecurrencia("");
        }
        // saveInputModalFecPro("");
        saveInputModalFecUlt(getAhorayyyymmdd()+"T00:00");
        saveInputModalHoras(0);
        saveTxtHeaderModal(inputDescripcion); 
        saveCheckModalAvisar(true);               
    }

    const accionCrear = async (e, continueLoading=false, clickBtnAceptarEjecutar=false) => {
        saveLoading(true);

        let idTrabajo = 0;
       
        const data = new FormData();                            
        data.append("validacion", apiKey());
        data.append("equipomantenimiento", selectIdEquipoModal);
        data.append("descripcion", inputDescripcion);
        data.append("fecpro", inputModalFecPro);
        data.append("fecult", inputModalFecUlt);
        data.append("avisar", checkModalAvisar);
        data.append("horas", inputModalHoras);
        data.append("hactuales", inputModalHActuales);
        data.append("accion", "crear");
        data.append("clickbtnaceptarejecutar", clickBtnAceptarEjecutar);        

        // // Adjuntos existentes
        // const inputs = document.querySelectorAll('input[name*="fileExistUrl"], input[name*="fileExist"]');        
        // for(let i=0; i<inputs.length; i++){
        //     data.append(inputs[i].name, inputs[i].value);
        // }  
        
        // Adjuntos nuevos datos
        const inputsNews = document.querySelectorAll('input[name*="fileNew**"], textarea[name*="fileNew**"], input[name*="fileNewUrl**"], textarea[name*="fileNewUrl**"]');        
        for(let i=0; i<inputsNews.length; i++){
            data.append(inputsNews[i].name, inputsNews[i].value);
        } 
        // Adjuntos nuevos ficheros
        for(let i = 0; i < adjuntos.length; i++ ){            
            if( !adjuntos[i].urlAdd ){
                data.append(adjuntos[i]["id"]+"[]", adjuntos[i]);
            }
        }        
        const respuesta = await axios.post(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.createdoc,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });                
               
        if( typeof respuesta.data === "string" ){            
            saveShowModal(false);
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }else{
            if(respuesta.data[0]){                                
                idTrabajo = respuesta.data[0];
            }
            await init();
            if(continueLoading==false){
                saveShowModal(false);
                saveLoading(false);
            }
            saveSelectIdEquipo(0);
            saveInputDescripcion("");
            saveSelectIdEquipoModal(0);
            saveInputModalFecPro("");
            saveInputModalFecUlt(getAhorayyyymmdd()+"T00:00");
            saveCheckModalAvisar(true);
            saveInputModalHoras(0);
            //Reseteamos los input de los adjuntos
            let adjs = document.querySelectorAll("input[type=file]");            
            for(let i=0; i<adjs.length; i++){
                adjs[i].value = null;
                adjs[i].files = null;
            }

            //Reseteamos los adjuntos pendientes de subir.
            saveAdjuntos([]);
        }

        await loadPendientesAsignar(); 

        return idTrabajo;
        
    }


    const showEditarLinea = (e, rowData) =>{                                 
        saveAccionModal("editar");        
        saveLineaEditar(rowData);  
        saveTxtHeaderModal(rowData.descripcionNoHtml);      
        saveSelectIdEquipoModal(rowData.idoriot);                 
        saveInputModalFecUlt(rowData.fecult+"T00:00");
        saveInputModalFecPro(rowData.fecpro+"T00:00");        
        saveInputModalHoras(rowData.horas);
        saveInputModalHActuales(rowData.hactuales);
        saveCheckModalAvisar(true);
        saveTipoRecurrenciaDocModal(rowData["recurrencia.tipo"]);
        saveRecurrencia(rowData.recurrencia);
        saveEquipoAsociadoMant(rowData.idequ);
        saveTotLin(rowData.totlin);
        saveEstDoc(rowData.idest);
        saveShowModal(true);
    }

    const accionEditar = async (e, continueLoading=false, clickBtnAceptarEjecutar=false) => {

        let idTrabajo = 0;

        if (new Date(inputModalFecUlt) > new Date(inputModalFecPro)){
            // Error la fecha de próxima ejecución debe ser posterior a la de última ejecución
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.manlogv2.txterrordates.title}`, {autoClose: true});   
            return;
        }
        
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());
        data.append("equipomantenimiento", selectIdEquipoModal);
        data.append("descripcion", inputDescripcion);
        data.append("fecpro", inputModalFecPro);
        data.append("fecult", inputModalFecUlt);
        data.append("avisar", checkModalAvisar);
        data.append("horas", inputModalHoras);
        data.append("hactuales", inputModalHActuales);
        data.append("accion", "editar");
        data.append("docedicion", JSON.stringify(lineaEditar));
        data.append("clickbtnaceptarejecutar", clickBtnAceptarEjecutar);

        // Adjuntos existentes       
        const inputs = document.querySelectorAll('input[name*="fileExistUrl"], input[name*="fileExist"]');        
        for(let i=0; i<inputs.length; i++){
            data.append(inputs[i].name, inputs[i].value);
        }          
        
        // Adjuntos nuevos datos
        const inputsNews = document.querySelectorAll('input[name*="fileNew**"], textarea[name*="fileNew**"], input[name*="fileNewUrl**"], textarea[name*="fileNewUrl**"]');        
        for(let i=0; i<inputsNews.length; i++){
            data.append(inputsNews[i].name, inputsNews[i].value);
        } 
        // Adjuntos nuevos ficheros
        for(let i = 0; i < adjuntos.length; i++ ){            
            if( !adjuntos[i].urlAdd ){
                data.append(adjuntos[i]["id"]+"[]", adjuntos[i]);
            }
        }        
        const respuesta = await axios.post(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.createdoc,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });     
               
        if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        if(respuesta.data[0]){                        
            idTrabajo = respuesta.data[0];
        }

        await init();
        if(continueLoading==false){
            saveLoading(false);
            saveShowModal(false);                
        }
        saveSelectIdEquipo(0);
        saveSelectIdEquipoModal(0);
        saveInputDescripcion("");
        //Reseteamos los input de los adjuntos
        let adjs = document.querySelectorAll("input[type=file]");            
        for(let i=0; i<adjs.length; i++){
            adjs[i].value = null;
            adjs[i].files = null;
        }

        //Reseteamos los adjuntos pendientes de subir.
        saveAdjuntos([]);

        return idTrabajo;
    }

    const ejecutar = async(e) => {

        if (new Date(inputModalFecUlt) > new Date(inputModalFecPro)){
            // Error la fecha de próxima ejecución debe ser posterior a la de última ejecución
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.manlogv2.txterrordates.title}`, {autoClose: true});   
            return;
        }

        let idTrabajo = 0;
        const equipoMantenimiento = selectIdEquipoModal;           
        if(accionModal == "editar"){
            idTrabajo = await accionEditar(e, true, true);
        }else{
            idTrabajo = await accionCrear(e, true, true);
        }
        saveLoading(true);

        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idtra", idTrabajo);
        data.append("accion", accionModal);
        data.append("equipomantenimiento", equipoMantenimiento);        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.ejecutar, data, source.token);

        if( typeof respuesta.data === "string" ){            
            saveShowModal(false);
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }else{
            // Redirigir al documentostrab
            props.history.push("/documentostrab/"+idTrabajo+"/null/null/manlogv2");
        }
        
        saveLoading(false);
        saveShowModal(false); 
    }
    
    const open = (e, rowData) => {          
        let ruta = rowData.ruta;
        const esUrl = ruta.startsWith('http://') || ruta.startsWith('https://') || ruta.startsWith('www.');
        const baseUrl = getApiUrl(window.location.origin);

        try {            
            if (ruta.startsWith('www.')) {
                ruta = `https://${ruta}`;
            }

            if (esUrl) {
                // Intentar abrir la URL en una nueva pestaña
                const nuevaVentana = window.open(ruta, '_blank');
                if (!nuevaVentana) {
                    alertService.error(`<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlogv2.txterroropen.title}`, { autoClose: true });
                }
            } else {
                // Comprobar si es un archivo local o una ruta relativa
                const archivoUrl = ruta.startsWith('file://') ? ruta : `${baseUrl}${ruta}`;
                const nuevaVentana = window.open(archivoUrl, '_blank');
                if (!nuevaVentana) {
                    alertService.error(`<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlogv2.txterroropen.title}`, { autoClose: true });
                }
            }
        } catch (error) {            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlogv2.txterroropen.title}`, { autoClose: true });
        }
    }

    const handleInputFecUltEje = async (e) => {        

        handleInput(e, saveInputModalFecUlt);        
        if(selectIdEquipoModal != 0){
            await recalculateFecProxEje(selectIdEquipoModal, e.target.value);
        }
    }

    const showMensaje = (e, rowData) =>{
        saveLineaEditar(rowData);                
        // saveSelectIdEquipoModal(rowData.idori);                 
        saveInputModalFecUlt(rowData.fecult+"T00:00");
        saveInputModalFecPro(rowData.fecpro+"T00:00");        
        saveInputModalHoras(rowData.horas);
        saveInputModalHActuales(rowData.hactuales);
        
        
        saveMensajeId(rowData.id);
        saveMensajeEstado(rowData.msg_idest);
        saveMensajeDe(rowData.from_idage);
        saveMensajePara(rowData.to_idage);
        saveMensajeEnvio(rowData.send_date+"T00:00");
        saveMensajeRecordatorio(rowData.rem_date+"T00:00");
        saveMensajeLimite(rowData.exp_date+"T00:00");
        saveMensajeLectura(rowData.read_date+"T00:00");
        saveMensajeMsg(rowData.msg_sub);
        
        saveShowModalMensaje(true);
    }

    const accionMensaje = async (e) => {

        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());
        data.append("id", mensajeId)
        data.append("msg_idest", mensajeEstado);
        data.append("rem_date", mensajeRecordatorio);
        data.append("exp_date", mensajeLimite);
        data.append("to_idage", mensajePara);
        data.append("msg_sub", mensajeMsg);        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.modalmensaje.updatemensaje, data, source.token);
               
        if( typeof respuesta.data !== "string" ){
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.manlogv2.modalmensaje.mensajeactualizado.title}`, {autoClose: true});
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }

        await loadMantenimientosPendientes();             

        saveLoading(false);
        saveShowModalMensaje(false);
        
    }

    const handleSelect = async (selectedItem, nameOfComponent, saveData, modal=false) => {        
        if( selectedItem ){            
            saveData(selectedItem.value)
            if(nameOfComponent.name == "idequ"){                               
                // saveTxtHeaderModal(selectedItem.lableNoHtml);
                saveEquipoAsociadoMant(selectedItem.idequ);
                saveInputModalHActuales(selectedItem.hactuales);
                saveTipoRecurrenciaDocModal(selectedItem["recurrencia.tipo"]);
                saveRecurrencia(selectedItem.recurrencia);
                saveTotLin(selectedItem.totlin);
                // saveEstDoc(selectedItem.idest);
                if(modal == false) saveInputDescripcion(selectedItem.lableNoHtml);
                if(selectedItem["recurrencia.tipo"] != 0){
                    await recalculateFecProxEje(selectedItem.value);
                }
            }            
        }else{
            saveData(0)
            if(nameOfComponent.name == "idequ"){ 
                saveTxtHeaderModal("");
                saveEquipoAsociadoMant(0);
                saveInputModalHActuales(0);
                saveInputDescripcion("");
                saveTipoRecurrenciaDocModal(0);
                saveRecurrencia("");
                saveTotLin(0);
                // saveEstDoc(0);
                saveInputModalFecPro("");
            } 
        }
    }

    const recalculateFecProxEje = async (idDoc, fecUlt=null) => {

        saveLoadingFecPro(true);        

        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("fecult", fecUlt != null ? fecUlt : inputModalFecUlt);
        data.append("equipomantenimiento", idDoc);        
        data.append("accion", accionModal);        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.recalculatefecproxeje, data, source.token);

        if( typeof respuesta.data === "string" ){                        
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }else{
            saveInputModalFecPro(respuesta.data[0]);
        }
        saveLoadingFecPro(false);
    }

    const setMantenimientoToForm = async (e, rowData) => {        
        saveSelectIdEquipo(rowData.id);
        saveInputDescripcion(rowData.descripcionnohtml);
        saveTipoRecurrenciaDocModal(rowData["recurrencia.tipo"]);        
        await recalculateFecProxEje(rowData.id);
    }

    const handleInput = (e, save) => {     
        save(e.target.value)
    }

    const handleCheck = (e, save) => {
        if( e.target.checked ){            
            save(true);
        }else{        
            save(false);
        }
    }

    const toogleAcordeon = (id) => {
        if( acordeonPrin == id ){
            saveAcordeonPrin(null);                    
        }else{
            saveAcordeonPrin(id);                    
        }        
    }


    
    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
            </div>   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Alert fondo={true} />
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">                
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section
                                tituloenhtml={true}
                                titulo={ confPantalla.manlogv2.section.titulo }  
                                icono={ confPantalla.manlogv2.section.icono } 
                                col={ confPantalla.manlogv2.section.col }
                                informes={confPantalla.manlogv2.controles.informes}
                            >
                             <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { selectIdEquipo  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.manlogv2.controles.idequ.id }    
                                    name=        { confPantalla.manlogv2.controles.idequ.name }   
                                    label=       { confPantalla.manlogv2.controles.idequ.label }    
                                    placeholder= { confPantalla.manlogv2.controles.idequ.placeholder }
                                    col=         { confPantalla.manlogv2.controles.idequ.col } 
                                    isClearable= { confPantalla.manlogv2.controles.idequ.isclearable }
                                    isSearchable={ confPantalla.manlogv2.controles.idequ.issearchable }
                                    dataType=    { confPantalla.manlogv2.controles.idequ.datatype }
                                    data=        { confPantalla.manlogv2.controles.idequ.data }
                                    required=    { confPantalla.manlogv2.controles.idequ.required } 
                                    disabled=  { confPantalla.manlogv2.controles.idequ.disabled }
                                    readOnly =   { confPantalla.manlogv2.controles.idequ.readonly }
                                    disablethisid={confPantalla.manlogv2.controles.idequ.disablethisid}
                                    disableids={confPantalla.manlogv2.controles.idequ.disableids}                                    
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveSelectIdEquipo) }
                                    saveBackUpOptions={saveBackUpOptionsSelectEquipo}
                                />
                                <FormInput
                                    clasesInput={ " inputRequired " }
                                    estadoForm= { "" }
                                    value=      { inputDescripcion }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlogv2.controles.descripcion.id }   
                                    type=       { confPantalla.manlogv2.controles.descripcion.type }  
                                    name=       { confPantalla.manlogv2.controles.descripcion.name }   
                                    label=      { confPantalla.manlogv2.controles.descripcion.label }                                                       
                                    placeholder={ confPantalla.manlogv2.controles.descripcion.placeholder }    
                                    col=        { confPantalla.manlogv2.controles.descripcion.col } 
                                    required=   { confPantalla.manlogv2.controles.descripcion.required }
                                    readonly=   { confPantalla.manlogv2.controles.descripcion.readonly }
                                    disabled=   { confPantalla.manlogv2.controles.descripcion.disabled }
                                    change=     { e => handleInput(e, saveInputDescripcion) }
                                    onBlur=     {null}
                                    autoCompleteData = {backUpOptionsSelectEquipo}
                                    saveSuggestion={saveInputDescripcion}                                    
                                    keyForSearch={"label"}
                                    keyToShow={"lableNoHtml"}                                    
                                />
                            </FormRow>
                            <p className="font-italic text-center">{ confPantalla.manlogv2.txtrequired.title }</p>                                
                            <Button 
                                clases={ "col-12 mt-2 mb-4" }
                                estadoForm={ loading ? "disabled" : "" }
                                color={ "success" }  
                                type="button" 
                                icono={ "" }   
                                id="btnnew"     
                                texto={ confPantalla.manlogv2.controles.btnnew.title }   
                                accion={ createNew } 
                                disabled={ inputDescripcion == "" || loading == true ? true : false }
                            />                             
                            {   loading == true ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }
                            <Accordion defaultActiveKey={""}  >
                                {/* <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => toogleAcordeon('0')} className={ acordeonPrin == "0" ? "activeAcordeon" : "" }>
                                        <i className={ confPantalla.manlogv2.controlmantenimientos.icono } ></i> { confPantalla.manlogv2.controlmantenimientos.titulo }
                                        {
                                            acordeonPrin == "0"
                                            ?
                                                <i className={"fal fa-chevron-up float-right fa-2x"} ></i>
                                            :
                                                <i className={"fal fa-chevron-down float-right fa-2x"} ></i>
                                        }
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0" className={"slowAcordeon"} >
                                        <Card.Body>                                        
                                            <MiDataTable 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"manlogv2mant"}
                                                columnas={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.columns}
                                                data={controlMantenimientos}
                                                buttons={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.buttons}
                                                ordering={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.ordering}
                                                order={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.order}
                                                searching={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.searching}
                                                paging={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.paging}
                                                select={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.select}
                                                pagelength={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.pagelength}
                                                // saveLoadingTable={ saveLoading }
                                                // loadingTable={loading}
                                                columnactions={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.columnactions.title}
                                                linkColumns={confPantalla.manlogv2.controles.datatablecontrolmantenimientos.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                functionClickTd={ open }                                
                                            />   
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>                                 */}
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => toogleAcordeon('1')} className={ acordeonPrin == "1" ? "activeAcordeon" : "" }>
                                        <i className={ confPantalla.manlogv2.mantenimientospendientes.icono } ></i> 
                                        { confPantalla.manlogv2.mantenimientospendientes.titulo } 
                                        <span className="alert-danger ml-2 pl-3 pr-3 pt-2 pb-2 " style={{borderRadius: "5px"}}>
                                            {getNumNoLeidosExcedidos(mantenimientosPendientes)}
                                        </span>
                                        <span className="alert-success ml-2 pl-3 pr-3 pt-2 pb-2 " style={{borderRadius: "5px"}}>
                                            {getNumNoLeidosEnPlazo(mantenimientosPendientes)}
                                        </span>
                                        {
                                            cookies.get('nivel') <= '3' 
                                            ? 
                                               <Fragment>
                                                    <span className='mr-1 ml-1'> / </span>
                                                    { confPantalla.manlogv2.avisosdemantenimientos.titulo }
                                                    <span className="alert-danger ml-2 pl-3 pr-3 pt-2 pb-2 " style={{borderRadius: "5px"}}>
                                                        {getNumFromDataTraPdtAsignar(pendientesAsignar, true, false)}
                                                    </span>
                                                    <span className="alert-success ml-2 pl-3 pr-3 pt-2 pb-2 " style={{borderRadius: "5px"}}>
                                                        {getNumFromDataTraPdtAsignar(pendientesAsignar, false, false)}
                                                    </span>
                                               </Fragment>
                                            : null
                                        }
                                        {
                                            acordeonPrin == "1"
                                            ?
                                                <i className={"fal fa-chevron-up float-right fa-2x"} ></i>
                                            :
                                                <i className={"fal fa-chevron-down float-right fa-2x"} ></i>
                                        }
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1" className={"slowAcordeon"} >
                                        <Card.Body>                                        
                                            <MiDataTable 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"manlogv2pend"}
                                                columnas={
                                                    cookies.get('nivel') > '3'
                                                    ? confPantalla.manlogv2.controles.datatablemantenimientospendientes.columnstrabajador
                                                    : confPantalla.manlogv2.controles.datatablemantenimientospendientes.columns
                                                }
                                                data={mantenimientosPendientes}
                                                buttons={confPantalla.manlogv2.controles.datatablemantenimientospendientes.buttons}
                                                ordering={confPantalla.manlogv2.controles.datatablemantenimientospendientes.ordering}
                                                order={confPantalla.manlogv2.controles.datatablemantenimientospendientes.order}
                                                searching={confPantalla.manlogv2.controles.datatablemantenimientospendientes.searching}
                                                paging={confPantalla.manlogv2.controles.datatablemantenimientospendientes.paging}
                                                select={confPantalla.manlogv2.controles.datatablemantenimientospendientes.select}
                                                pagelength={confPantalla.manlogv2.controles.datatablemantenimientospendientes.pagelength}
                                                // saveLoadingTable={ saveLoading }
                                                // loadingTable={loading}
                                                columnactions={confPantalla.manlogv2.controles.datatablemantenimientospendientes.columnactions.title}
                                                linkColumns={confPantalla.manlogv2.controles.datatablemantenimientospendientes.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                functionClickTd={ showMensaje }
                                                clickBtnDataTableButtons={loadMantenimientosPendientes}                               
                                            />
                                            {
                                                cookies.get('nivel') <= '3' 
                                                ?
                                                    <Fragment>
                                                        {/* <div className="row justify-content-md-center">                                             
                                                            <div className="col-md-12 col-lg-2">
                                                                <div className="alert alert-danger alertHelp" role="alert">
                                                                    {getNumFromDataTraPdtAsignar(pendientesAsignar, true)}
                                                                    {confPantalla.manlogv2.controles.datatablependientesdeasignar.leyendapendientes.excedido.title}
                                                                </div>
                                                            </div>                                            
                                                            <div className="col-md-12 col-lg-2">
                                                                <div className="alert alert-success alertHelp" role="alert">
                                                                    {getNumFromDataTraPdtAsignar(pendientesAsignar, false)}
                                                                    {confPantalla.manlogv2.controles.datatablependientesdeasignar.leyendapendientes.enplazo.title}
                                                                </div>
                                                            </div>                                                       
                                                        </div> */}
                                                        <MiDataTable 
                                                            estadoForm= { "" }
                                                            formulario={ {id:0} }
                                                            id={"manlogv2pendientesdeasignar"}
                                                            columnas={confPantalla.manlogv2.controles.datatablependientesdeasignar.columns}
                                                            data={pendientesAsignar}
                                                            linkColumns={confPantalla.manlogv2.controles.datatablependientesdeasignar.linkColumns}
                                                            buttons={confPantalla.manlogv2.controles.datatablependientesdeasignar.buttons}
                                                            ordering={confPantalla.manlogv2.controles.datatablependientesdeasignar.ordering}
                                                            order={confPantalla.manlogv2.controles.datatablependientesdeasignar.order}
                                                            searching={confPantalla.manlogv2.controles.datatablependientesdeasignar.searching}
                                                            paging={confPantalla.manlogv2.controles.datatablependientesdeasignar.paging}
                                                            select={confPantalla.manlogv2.controles.datatablependientesdeasignar.select}
                                                            pagelength={confPantalla.manlogv2.controles.datatablependientesdeasignar.pagelength}
                                                            // saveLoadingTable={ saveLoadingTable }
                                                            // loadingTable={loadingTable}
                                                            columnactions={confPantalla.manlogv2.controles.datatablependientesdeasignar.columnactions.title}
                                                            traduction={confPantalla.config.trad.components.datatable}
                                                            functionClickTd={ setMantenimientoToForm }
                                                        />
                                                    </Fragment>
                                                :
                                                    null
                                            }
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => toogleAcordeon('2')} className={ acordeonPrin == "2" ? "activeAcordeon" : "" }>
                                        <i className={ confPantalla.manlogv2.historicos.icono } ></i> { confPantalla.manlogv2.historicos.titulo }
                                        {
                                            acordeonPrin == "2"
                                            ?
                                                <i className={"fal fa-chevron-up float-right fa-2x"} ></i>
                                            :
                                                <i className={"fal fa-chevron-down float-right fa-2x"} ></i>
                                        }
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="2" className={"slowAcordeon"} >
                                        <Card.Body>                                        
                                            <MiDataTable 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"manlogv2his"}
                                                columnas={confPantalla.manlogv2.controles.datatablehistoricos.columns}
                                                data={historicos}
                                                buttons={confPantalla.manlogv2.controles.datatablehistoricos.buttons}
                                                ordering={confPantalla.manlogv2.controles.datatablehistoricos.ordering}
                                                order={confPantalla.manlogv2.controles.datatablehistoricos.order}
                                                searching={confPantalla.manlogv2.controles.datatablehistoricos.searching}
                                                paging={confPantalla.manlogv2.controles.datatablehistoricos.paging}
                                                select={confPantalla.manlogv2.controles.datatablehistoricos.select}
                                                pagelength={confPantalla.manlogv2.controles.datatablehistoricos.pagelength}
                                                // saveLoadingTable={ saveLoading }
                                                // loadingTable={loading}
                                                columnactions={confPantalla.manlogv2.controles.datatablehistoricos.columnactions.title}
                                                linkColumns={confPantalla.manlogv2.controles.datatablehistoricos.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                // functionClickTd={ cookies.get('nivel') <= '2' ? showEditarLinea : null }
                                                functionClickTd={ showEditarLinea }                                                
                                            />   
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                {
                    showModal == true
                    ?
                    <Modal
                        show={showModal}
                        onHide={ () => saveShowModal(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        {/* <Modal.Header closeButton> */}
                        <Modal.Header>
                            <div className='col-12' style={{display: "flex", justifyContent: "space-between" , alignItems: "center"}}>
                                {/* <h4>{confPantalla.manlogv2.modal.header.title}</h4>  */}
                                <h4>{txtHeaderModal}</h4>
                                {
                                    recurrencia != "" 
                                    ? 
                                        <span className='alert-primary pl-3 pr-3 pt-2 pb-2 float-right' style={{borderRadius: "5px"}} >
                                                {recurrencia}
                                        </span>
                                    :
                                        null
                                }
                            </div>                            
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                {
                                    // cookies.get('nivel') == 4 && (selectIdEquipoModal == 0 && accionModal == "crear")
                                    cookies.get('nivel') <= 3 || (cookies.get('nivel') == 4 && selectIdEquipo == 0)
                                    ?
                                        <MiSelect  
                                            estadoForm=  { "" }
                                            val=         { selectIdEquipoModal  }   
                                            loading=     { loading ? true : false }
                                            id=          { confPantalla.manlogv2.controles.idequ.id }    
                                            name=        { confPantalla.manlogv2.controles.idequ.name }   
                                            label=       { confPantalla.manlogv2.controles.idequ.label }    
                                            placeholder= { confPantalla.manlogv2.controles.idequ.placeholder }
                                            col=         { 12 } 
                                            isClearable= { confPantalla.manlogv2.controles.idequ.isclearable }
                                            isSearchable={ confPantalla.manlogv2.controles.idequ.issearchable }
                                            dataType=    { confPantalla.manlogv2.controles.idequ.datatype }
                                            data=        { confPantalla.manlogv2.controles.idequ.data }
                                            required=    { confPantalla.manlogv2.controles.idequ.required } 
                                            disabled=  { confPantalla.manlogv2.controles.idequ.disabled }
                                            readOnly =   { confPantalla.manlogv2.controles.idequ.readonly }
                                            disablethisid={confPantalla.manlogv2.controles.idequ.disablethisid}
                                            disableids={confPantalla.manlogv2.controles.idequ.disableids}                                    
                                            formulario= { {id:0} }   
                                            change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveSelectIdEquipoModal, true) }
                                            saveBackUpOptions={saveBackUpOptionsSelectEquipo}
                                        />
                                    : 
                                    //     cookies.get('nivel') <= 3
                                    // ?
                                        null
                                        // <MiSelect  
                                        //     estadoForm=  { "" }
                                        //     val=         { selectIdEquipoModal  }   
                                        //     loading=     { loading ? true : false }
                                        //     id=          { confPantalla.manlogv2.controles.idequ.id }    
                                        //     name=        { confPantalla.manlogv2.controles.idequ.name }   
                                        //     label=       { confPantalla.manlogv2.controles.idequ.label }    
                                        //     placeholder= { confPantalla.manlogv2.controles.idequ.placeholder }
                                        //     col=         { 12 } 
                                        //     isClearable= { confPantalla.manlogv2.controles.idequ.isclearable }
                                        //     isSearchable={ confPantalla.manlogv2.controles.idequ.issearchable }
                                        //     dataType=    { confPantalla.manlogv2.controles.idequ.datatype }
                                        //     data=        { confPantalla.manlogv2.controles.idequ.data }
                                        //     required=    { confPantalla.manlogv2.controles.idequ.required } 
                                        //     disabled=  { confPantalla.manlogv2.controles.idequ.disabled }
                                        //     readOnly =   { confPantalla.manlogv2.controles.idequ.readonly }
                                        //     disablethisid={confPantalla.manlogv2.controles.idequ.disablethisid}
                                        //     disableids={confPantalla.manlogv2.controles.idequ.disableids}                                    
                                        //     formulario= { {id:0} }   
                                        //     change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveSelectIdEquipoModal, true) }
                                        //     saveBackUpOptions={saveBackUpOptionsSelectEquipo}
                                        // />
                                    // :
                                    //     null
                                }                                
                            </FormRow>
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                {
                                    selectIdEquipoModal == 0
                                    ?
                                        <div className="alert alert-danger text-center mr-1" role="alert">
                                            {confPantalla.manlogv2.modal.txterrorman.title}
                                        </div>
                                    :
                                        null
                                }
                                {
                                    equipoAsociadoMant == 0 && accionModal == "editar"
                                    ?
                                        <div className="alert alert-danger text-center mr-1" role="alert">
                                            {confPantalla.manlogv2.modal.txterrorequipo.title}
                                        </div>
                                    :
                                        null
                                }
                            </div>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputModalFecUlt }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlogv2.modal.fecult.id }   
                                    type=       { confPantalla.manlogv2.modal.fecult.type }  
                                    name=       { confPantalla.manlogv2.modal.fecult.name }   
                                    label=      { confPantalla.manlogv2.modal.fecult.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modal.fecult.placeholder }    
                                    col=        { confPantalla.manlogv2.modal.fecult.col } 
                                    required=   { confPantalla.manlogv2.modal.fecult.required }
                                    readonly=   { cookies.get('nivel') == 4 && accionModal == "editar" ? "readonly" : "" }
                                    disabled=   { confPantalla.manlogv2.modal.fecult.disabled }
                                    change=     { e => handleInputFecUltEje(e) }
                                    // change=     { e => handleInput(e, saveInputModalFecUlt) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputModalHoras }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlogv2.modal.horas.id }   
                                    type=       { confPantalla.manlogv2.modal.horas.type }  
                                    name=       { confPantalla.manlogv2.modal.horas.name }   
                                    label=      { confPantalla.manlogv2.modal.horas.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modal.horas.placeholder }    
                                    col=        { confPantalla.manlogv2.modal.horas.col } 
                                    required=   { cookies.get('nivel') == 4 && accionModal == "editar" ? "readonly" : "" }
                                    readonly=   { confPantalla.manlogv2.modal.horas.readonly }
                                    disabled=   { confPantalla.manlogv2.modal.horas.disabled }
                                    change=     { e => handleInput(e, saveInputModalHoras) }
                                    onBlur=     {null}                                    
                                />
                                {/* {
                                selectIdEquipoModal > 0 && equipoAsociadoMant > 0
                                ? */}
                                    <FormInput                                                        
                                        estadoForm= { "" }
                                        value=      { inputModalHActuales }
                                        loading=    { loading ? true : false }
                                        id=         { confPantalla.manlogv2.modal.hactuales.id }   
                                        type=       { confPantalla.manlogv2.modal.hactuales.type }  
                                        name=       { confPantalla.manlogv2.modal.hactuales.name }   
                                        label=      { confPantalla.manlogv2.modal.hactuales.label }                                                       
                                        placeholder={ confPantalla.manlogv2.modal.hactuales.placeholder }    
                                        col=        { confPantalla.manlogv2.modal.hactuales.col } 
                                        required=   { confPantalla.manlogv2.modal.hactuales.required }
                                        readonly=   { confPantalla.manlogv2.modal.hactuales.readonly }
                                        disabled=   { confPantalla.manlogv2.modal.hactuales.disabled }
                                        change=     { e => handleInput(e, saveInputModalHActuales) }
                                        onBlur=     {null}                                    
                                    />
                                {/* :
                                    null
                                } */}
                                {
                                selectIdEquipoModal > 0 && tipoRecurrenciaDocModal > 0
                                ?
                                    <Fragment>
                                        <FormInput                                                        
                                            estadoForm= { "" }
                                            value=      { inputModalFecPro }
                                            loading=    { loading || loadingFecPro ? true : false }
                                            id=         { confPantalla.manlogv2.modal.fecpro.id }   
                                            type=       { confPantalla.manlogv2.modal.fecpro.type }  
                                            name=       { confPantalla.manlogv2.modal.fecpro.name }   
                                            label=      { confPantalla.manlogv2.modal.fecpro.label }                                                       
                                            placeholder={ confPantalla.manlogv2.modal.fecpro.placeholder }    
                                            col=        { confPantalla.manlogv2.modal.fecpro.col } 
                                            required=   { confPantalla.manlogv2.modal.fecpro.required }
                                            readonly=   { confPantalla.manlogv2.modal.fecpro.readonly }
                                            disabled=   { confPantalla.manlogv2.modal.fecpro.disabled }
                                            change=     { e => handleInput(e, saveInputModalFecPro) }
                                            onBlur=     {null} 
                                        />                                                               
                                        <CheckIos                                
                                            val= { checkModalAvisar }
                                            name={null}
                                            label={ confPantalla.manlogv2.modal.avisar.title }                                
                                            id={'checkavisar'}
                                            col={"3"}
                                            change={ e=> handleCheck(e, saveCheckModalAvisar) }
                                            required={ false }
                                            disabled={ false }                               
                                        /> 
                                    </Fragment>
                                :
                                    null
                                }                                                                 
                            </FormRow>                            
                            <UplmPlusBtn
                                idReg={accionModal == "editar" ? lineaEditar.id : 0}
                                id={ confPantalla.manlogv2.modal.uplmplusbtn.id }
                                getAdj={confPantalla.manlogv2.modal.uplmplusbtn.getadj}
                                saveAdj={confPantalla.manlogv2.modal.uplmplusbtn.saveadj}
                                estadoForm= { cookies.get('nivel') == 4 && accionModal == "editar" ? "readonly" : "" }
                                col={12}
                                readonly={ confPantalla.manlogv2.modal.uplmplusbtn.readonly }
                                traduction={confPantalla.config.trad.components}                                                            
                                datatable={ confPantalla.manlogv2.modal.uplmplusbtn.datatable }
                                select={ confPantalla.manlogv2.modal.uplmplusbtn.select }
                                noBtn={true}
                                noModal={true}
                                saveAdjuntosParam={saveAdjuntos}
                            />                                                        
                            <p className="font-italic text-center">{ confPantalla.manlogv2.txtrequired.title }</p>
                            {   loading ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                            {                                    
                                    selectIdEquipoModal > 0 && totLin > 0 && cookies.get('nivel') < '4'
                                    ?
                                        // <div className='text-right col-md-2'>                                            
                                            <button className='btn btn-outline-success  mt-1 mr-1' style={{marginTop: '32px'}}  
                                                    onClick={ e => ejecutar(e) }
                                                    disabled={ loading == true ? true : false}
                                                    >
                                                <i className="fal fa-bolt mr-1"></i>
                                                {confPantalla.manlogv2.modal.btnaceptaryejecutar.title}
                                            </button>
                                        // </div>
                                    :
                                    (selectIdEquipoModal > 0 && totLin > 0 && cookies.get('nivel') == '4' && estDoc == '8') || 
                                    (selectIdEquipoModal > 0 && totLin > 0 && cookies.get('nivel') == '4' && accionModal == "crear")
                                    ?
                                        // <div className='text-right col-md-2'>                                            
                                            <button className='btn btn-outline-success  mt-1 mr-1' style={{marginTop: '32px'}}  
                                                    onClick={ e => ejecutar(e) }
                                                    disabled={ loading == true ? true : false}
                                                    >
                                                <i className="fal fa-bolt mr-1"></i>
                                                {confPantalla.manlogv2.modal.btnaceptaryejecutar.title}
                                            </button>
                                        // </div>
                                    :
                                        null
                                } 
                                {
                                    accionModal == "editar"
                                    ?
                                        <button 
                                                className="btn btn-success mt-1 mr-1"
                                                onClick={ e => accionEditar(e, false) }
                                                disabled={ loading == true ? true : false}
                                        >
                                            {confPantalla.manlogv2.modal.btnaceptar.title}
                                        </button>
                                    :
                                        <button 
                                            className="btn btn-success mt-1 mr-1"
                                            onClick={ e => accionCrear(e, false) }
                                            disabled={ loading == true ? true : false}
                                        >
                                            {confPantalla.manlogv2.modal.btnaceptar.title}
                                        </button>
                                }
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModal(false) }
                                        disabled={ loading == true ? true : false}                                        
                                >
                                    {confPantalla.manlogv2.modal.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
                {
                    showModalMensaje == true
                    ?
                    <Modal
                        show={showModalMensaje}
                        onHide={ () => saveShowModalMensaje(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        {/* <Modal.Header closeButton> */}
                        <Modal.Header>
                            <div className='col-12' style={{display: "flex", justifyContent: "space-between" , alignItems: "center"}}>
                                <h4>{confPantalla.manlogv2.modalmensaje.header.title}</h4>                                 
                            </div>                            
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { mensajeEstado }   
                                    loading=     { loadReg ? true : false }
                                    id=          { confPantalla.manlogv2.modalmensaje.msg_idest.id }    
                                    name=        { confPantalla.manlogv2.modalmensaje.msg_idest.name }   
                                    label=       { confPantalla.manlogv2.modalmensaje.msg_idest.label }    
                                    placeholder= { confPantalla.manlogv2.modalmensaje.msg_idest.placeholder }
                                    col=         { confPantalla.manlogv2.modalmensaje.msg_idest.col } 
                                    isClearable= { confPantalla.manlogv2.modalmensaje.msg_idest.isclearable }
                                    isSearchable={ confPantalla.manlogv2.modalmensaje.msg_idest.issearchable }
                                    dataType=    { confPantalla.manlogv2.modalmensaje.msg_idest.datatype }
                                    data=        { confPantalla.manlogv2.modalmensaje.msg_idest.data }
                                    required=    { confPantalla.manlogv2.modalmensaje.msg_idest.required } 
                                    disabled=  { confPantalla.manlogv2.modalmensaje.msg_idest.disabled }
                                    readOnly =   { confPantalla.manlogv2.modalmensaje.msg_idest.readonly }
                                    disablethisid={confPantalla.manlogv2.modalmensaje.msg_idest.disablethisid}
                                    disableids={confPantalla.manlogv2.modalmensaje.msg_idest.disableids}                                    
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveMensajeEstado)  }
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeRecordatorio }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.rem_date.id }   
                                    type=       { confPantalla.manlogv2.modalmensaje.rem_date.type }  
                                    name=       { confPantalla.manlogv2.modalmensaje.rem_date.name }   
                                    label=      { confPantalla.manlogv2.modalmensaje.rem_date.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.rem_date.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.rem_date.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.rem_date.required }
                                    readonly=   { confPantalla.manlogv2.modalmensaje.rem_date.readonly }
                                    disabled=   { confPantalla.manlogv2.modalmensaje.rem_date.disabled }                                    
                                    change=     { e => handleInput(e, saveMensajeRecordatorio) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeLimite }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.exp_date.id }   
                                    type=       { confPantalla.manlogv2.modalmensaje.exp_date.type }  
                                    name=       { confPantalla.manlogv2.modalmensaje.exp_date.name }   
                                    label=      { confPantalla.manlogv2.modalmensaje.exp_date.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.exp_date.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.exp_date.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.exp_date.required }
                                    readonly=   { cookies.get('nivel') > '3' ? "readonly" : confPantalla.manlogv2.modalmensaje.exp_date.readonly }
                                    disabled=   { cookies.get('nivel') > '3' ? "disabled" : confPantalla.manlogv2.modalmensaje.exp_date.disabled }
                                    change=     { e => handleInput(e, saveMensajeLimite) }
                                    onBlur=     {null} 
                                />                                 
                            </FormRow>
                            <FormRow clases="" >
                                {/* <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { mensajeDe  }   
                                    loading=     { loadReg ? true : false }
                                    id=          { confPantalla.manlogv2.modalmensaje.from_idage.id }    
                                    name=        { confPantalla.manlogv2.modalmensaje.from_idage.name }   
                                    label=       { confPantalla.manlogv2.modalmensaje.from_idage.label }    
                                    placeholder= { confPantalla.manlogv2.modalmensaje.from_idage.placeholder }
                                    col=         { confPantalla.manlogv2.modalmensaje.from_idage.col } 
                                    isClearable= { confPantalla.manlogv2.modalmensaje.from_idage.isclearable }
                                    isSearchable={ confPantalla.manlogv2.modalmensaje.from_idage.issearchable }
                                    dataType=    { confPantalla.manlogv2.modalmensaje.from_idage.datatype }
                                    data=        { confPantalla.manlogv2.modalmensaje.from_idage.data }
                                    required=    { confPantalla.manlogv2.modalmensaje.from_idage.required } 
                                    disabled=  { confPantalla.manlogv2.modalmensaje.from_idage.disabled }
                                    readOnly =   { confPantalla.manlogv2.modalmensaje.from_idage.readonly }
                                    disablethisid={confPantalla.manlogv2.modalmensaje.from_idage.disablethisid}
                                    disableids={confPantalla.manlogv2.modalmensaje.from_idage.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveMensajeDe) }
                                />  */}
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { mensajePara  }   
                                    loading=     { loadReg ? true : false }
                                    id=          { confPantalla.manlogv2.modalmensaje.to_idage.id }    
                                    name=        { confPantalla.manlogv2.modalmensaje.to_idage.name }   
                                    label=       { confPantalla.manlogv2.modalmensaje.to_idage.label }    
                                    placeholder= { confPantalla.manlogv2.modalmensaje.to_idage.placeholder }
                                    col=         { confPantalla.manlogv2.modalmensaje.to_idage.col } 
                                    isClearable= { confPantalla.manlogv2.modalmensaje.to_idage.isclearable }
                                    isSearchable={ confPantalla.manlogv2.modalmensaje.to_idage.issearchable }
                                    dataType=    { confPantalla.manlogv2.modalmensaje.to_idage.datatype }
                                    data=        { confPantalla.manlogv2.modalmensaje.to_idage.data }
                                    required=    { confPantalla.manlogv2.modalmensaje.to_idage.required } 
                                    disabled=  { cookies.get('nivel') > '3' ? "disabled" : confPantalla.manlogv2.modalmensaje.to_idage.disabled }
                                    readOnly =   { cookies.get('nivel') > '3' ? "readonly" : confPantalla.manlogv2.modalmensaje.to_idage.readonly }
                                    disablethisid={confPantalla.manlogv2.modalmensaje.to_idage.disablethisid}
                                    disableids={confPantalla.manlogv2.modalmensaje.to_idage.disableids}                                    
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveMensajePara) }
                                />                                                               
                            </FormRow>
                            {/* <FormRow> */}
                                {/* <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeEnvio }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.send_date.id }   
                                    type=       { confPantalla.manlogv2.modalmensaje.send_date.type }  
                                    name=       { confPantalla.manlogv2.modalmensaje.send_date.name }   
                                    label=      { confPantalla.manlogv2.modalmensaje.send_date.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.send_date.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.send_date.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.send_date.required }
                                    readonly=   { confPantalla.manlogv2.modalmensaje.send_date.readonly }
                                    disabled=   { confPantalla.manlogv2.modalmensaje.send_date.disabled }
                                    change=     { e => handleInput(e, saveMensajeEnvio) }
                                    onBlur=     {null} 
                                /> */}                                
                                {/* <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeLectura }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.read_date.id }   
                                    type=       { confPantalla.manlogv2.modalmensaje.read_date.type }  
                                    name=       { confPantalla.manlogv2.modalmensaje.read_date.name }   
                                    label=      { confPantalla.manlogv2.modalmensaje.read_date.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.read_date.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.read_date.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.read_date.required }
                                    readonly=   { confPantalla.manlogv2.modalmensaje.read_date.readonly }
                                    disabled=   { confPantalla.manlogv2.modalmensaje.read_date.disabled }
                                    change=     { e => handleInput(e, saveMensajeLectura) }
                                    onBlur=     {null} 
                                /> */}
                            {/* </FormRow> */}
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeMsg }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.msg_sub.id }   
                                    name=       { confPantalla.manlogv2.modalmensaje.msg_sub.name }
                                    rows=       { confPantalla.manlogv2.modalmensaje.msg_sub.rows }      
                                    label=      { confPantalla.manlogv2.modalmensaje.msg_sub.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.msg_sub.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.msg_sub.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.msg_sub.required }
                                    readonly=   { confPantalla.manlogv2.modalmensaje.msg_sub.readonly }                                                
                                    disabled=   { confPantalla.manlogv2.modalmensaje.msg_sub.disabled }
                                    change=     { e => handleInput(e, saveMensajeMsg) }
                                    onBlur=     {null} 
                                />
                            </FormRow>                                                                                  
                            {   loading ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>                                                                  
                                <button className='btn btn-success mt-1 mr-1' style={{marginTop: '32px'}}  
                                    onClick={ e => accionMensaje(e) }
                                    disabled={ loading == true ? true : false}
                                >                                    
                                    {confPantalla.manlogv2.modalmensaje.btnaceptar.title}
                                </button>                                                                       
                                <button 
                                    className="btn btn-danger mt-1"
                                    onClick={ () => saveShowModalMensaje(false) }
                                    disabled={ loading == true ? true : false}                                        
                                >
                                    {confPantalla.manlogv2.modalmensaje.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default Manlogv2V2;